import { Directive, ElementRef, HostListener, Input, OnChanges, Renderer2 } from '@angular/core';

@Directive({
  selector: '[appScrollable]'
})
export class ScrollableDirective implements OnChanges {

    @Input() appScrollable: any;

    @HostListener('touchmove', ['$event'])
    @HostListener('mousewheel', ['$event'])
    @HostListener('DOMMouseScroll', ['$event'])
    @HostListener('mousedown', ['$event'])
    private stopPropagation (event: Event) {
        event.stopPropagation();
    }

    constructor (private el: ElementRef, private renderer: Renderer2) {}

    ngOnChanges () {
        this.renderer.setProperty(this.el.nativeElement, 'scrollTop', 0);
        this.renderer.setProperty(this.el.nativeElement, 'scrollLeft', 0);
    }
}
